import T from 'i18n-react';
import { history } from '../index';
import * as CommonState from './Common';

const initialState = {
    quickPayModalVisible: false,
    quickPayErrorMessage: '',
    quickPayAccount: {},
    quickPayAccountFound: false,
    quickPaymentSuccess: false,
    quickPayConfirmationNumber: '',
    userLoading: false,
    userErrorMessage: '',
    userErrorMessageModal: '',
    userSourceError: '',
    forgotPasswordConfirmation: false,
    forgotUsernameConfirmation: false,
    registerPerson: {},
    registerConfirmation: false,
    verificationCodeConfirmation: false,
    accountVerificationConfirmation: false,
    verifiedEnrollment: false,
    usernameUpdateConfirmation: false,
    confirmRememberMe: false,
    resetPwdInfo: { resetToken: '', resetTokenSuccess: false },
    accountVerified: false
};

export const actionCreators = {

    forgotPassword: (request) => async (dispatch, getState) => {

        const state = getState();
        let headers = { ...CommonState.headers };
        headers.Authorization = state.common.publicToken;

        // force CSRF token in the header
        const csrfToken = await CommonState.fetchCSRFToken();
        if (!csrfToken) {
            console.error("Failed to get CSRF token");
            return;
        }
        headers['X-MyAccount-CSRF-TOKEN'] = csrfToken; 

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/ResetPassword`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {

                if (!data.isError) {
                    dispatch({ type: 'SET_FORGOT_PASSWORD_CONFIRMATION', forgotPasswordConfirmation: true });
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: T.translate('forgot.cannotResetPassword') });
                }
            })
            .catch(function (error) {
                if (error.message === 'Account user not found') {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: T.translate('forgot.cannotFindUser') });
                }
                else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
                }
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    validatePasswordReset: (data) => (dispatch, getState) => {
        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;
        data.languageID = state.common.langID;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/PasswordResetToken`, { headers: headers, method: 'POST', body: JSON.stringify(data), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(resp => {

                if (resp.token) {
                    dispatch({ type: 'SET_VALID_PASSWORD_RESET_TOKEN', resetPwdInfo: { resetToken: resp.token } });
                } else {
                    var errorMessage = resp.isError ? resp.errorMessage : T.translate('accountResetPassword.invalidToken');
                    var userSourceError = resp.isExpiredToken ? 'ExpiredToken' : '';

                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: errorMessage, userSourceError: userSourceError });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });
    },

    updatePasswordWithToken: (data) => (dispatch, getState) => {
        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let request = {
            password: data.fields['new-password'].value,
            token: data.token
        };

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/PasswordWithToken`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(resp => {

                if (resp.personID) {
                    dispatch({ type: 'SET_AUTOLOGIN_TOKEN', resetPwdInfo: { resetToken: '', resetTokenSuccess: true } });
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: T.translate('login.invalidUsernamePassword') });
                }

            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    newPasswordResetLink: (data) => (dispatch, getState) => {
        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;
        data.languageID = state.common.langID;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/NewPasswordResetToken`, { headers: headers, method: 'POST', body: JSON.stringify(data), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(resp => {
            
                if (!resp.isError) {
                    dispatch({ type: 'SET_FORGOT_PASSWORD_CONFIRMATION', forgotPasswordConfirmation: true });
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: data.errorMessage });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });
    },

    sendVerificationCode: (user) => (dispatch, getState) => {
        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let req = {};
        req.userName = user.username;
        req.password = user.password;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/VerificationCode`, { headers: headers, method: 'POST', body: JSON.stringify(req), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                dispatch({ type: 'SET_VERIFICATION_CODE_CONFIRMATION', verificationCodeConfirmation: true });
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    sendVerificationCodeByUsername: (user) => (dispatch, getState) => {
        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let req = {};
        req.userName = user.userNameModal;

        fetch(`${state.common.serviceUrl}/VerificationCodeByUserName`, { headers: headers, method: 'POST', body: JSON.stringify(req), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                dispatch({ type: 'SET_VERIFICATION_CODE_CONFIRMATION', verificationCodeConfirmation: true });
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR_FOR_MODAL', userErrorMessageModal: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    updateUserName: (view) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let persons = [];

        if (state.account.accountPersons && state.account.accountPersons.length > 0) {
            state.account.accountPersons.forEach(function (a) {
                persons.push(a.persons[0]);
            });
        }

        let request = {};
        request.persons = persons;
        request.password = state.account.password;
        request.userName = view.useEmailAddress ? view.userNameEmailAddress : view.userNameMobilePhone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');

        fetch(`${state.common.serviceUrl}/UserName`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {

                dispatch({ type: 'REQUEST_USER_END' });
                history.push('/');

            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'SET_USERNAME_UPDATE_CONFIRMATION', usernameUpdateConfirmation: false, confirmRememberMe: false });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    validateVerificationCode: (code) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let request = {};
        request["token"] = code;
        request["languageID"] = state.common.langID;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/ValidateVerificationCode`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                if (!data.isError) {

                    if (data.isAccountVerified) {
                        return dispatch({ type: 'SET_ACCOUNT_VERIFIED', accountVerified: true });
                    }

                    dispatch({ type: 'SET_ACCOUNT_VERIFICATION_CONFIRMATION', accountVerificationConfirmation: true });

                } else {
                    var userSourceError = data.isExpiredToken ? 'ExpiredToken' : '';

                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: data.errorMessage, userSourceError: userSourceError });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    regenerateVerificationCode: (code) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let request = {};
        request["token"] = code;
        request["languageID"] = state.common.langID;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/NewVerificationCode`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                if (!data.isError) {
                    dispatch({ type: 'SET_VERIFICATION_CODE_CONFIRMATION', verificationCodeConfirmation: true });
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: data.errorMessage });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    validateEnrollmentCode: (code) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/ValidateEnrollmentCode`, { headers: headers, method: 'POST', body: JSON.stringify(code), credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                if (!data.isError) {
                    dispatch({ type: 'SET_ENROLLMENT_VERIFICATION', verifiedEnrollment: data.isValid });
                }
                else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: data.errorMessage });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    getRegister: (view) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        let request = {};
        request.accountNumber = view.accountNumber;
        request.zipCode = view.zipCode;
        request.addressOrigin = view.addressOrigin;
        request.email = view.email;
        request.phoneNumber = view.phone ? view.phone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '') : '';

        var queryString = Object.keys(request).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(request[key])).join('&');

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/Register?${queryString}`, { headers: headers, method: 'GET', credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                if (data.person) {
                    dispatch({ type: 'SET_REGISTER_USER_FOUND', registerUserFound: true, registerPerson: data.person });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'SET_REGISTER_USER_FOUND', registerUserFound: false, registerPerson: {} });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    validateConvertedAccount: (view) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;
        const externalUrl = state.common.systemProperties.externalConversionUrl;

        let request = {};
        request.accountNumber = view.accountNumber;
        request.email = view.email;
        request.phoneNumber = view.phone ? view.phone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '') : '';

        var queryString = Object.keys(request).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(request[key])).join('&');

        fetch(`${state.common.serviceUrl}/ValidateConvertedAccount?${queryString}`, { headers: headers, method: 'GET', credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {

                if (!data.isError) {
                    if (data.isValidRegistration) {
                        history.push(`/register?account=${view.accountNumber}&email=${view.email}`);
                    } else if (data.accountID) {
                        dispatch({ type: 'SET_ACCOUNT_REGISTERED', accountRegistered: true });
                    } else if (externalUrl) {
                        window.location.replace(externalUrl);
                    }
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: data.errorMessage });
                }

            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    register: (request) => async (dispatch, getState) => {

        const state = getState();
        let headers = { ...CommonState.headers };
        headers.Authorization = state.common.publicToken;

        // force CSRF token in the header
        const csrfToken = await CommonState.fetchCSRFToken();
        if (!csrfToken) {
            console.error("Failed to get CSRF token");
            return;
        }
        headers['X-MyAccount-CSRF-TOKEN'] = csrfToken;

        request.userName = request.useEmailAddress ? request.userNameEmailAddress : request.userNameMobilePhone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
        request.personID = state.user.registerPerson.personID;
        request.phoneNumber = request.phone ? request.phone.replace(' ', '').replace('(', '').replace(')', '').replace('-', '') : '';

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/Register`, { headers: headers, method: 'POST', body: JSON.stringify(request), credentials: "same-origin"})
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {
                if (data.isValidRegistration) {
                    dispatch({ type: 'SET_REGISTER_CONFIRMATION', registerConfirmation: true });
                } else {
                    dispatch({ type: 'SET_USER_ERROR', userErrorMessage: T.translate('register.noAccountFound') });
                }
            })
            .catch(function (error) {
                dispatch({ type: 'SET_USER_ERROR', userErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    getAccount: (request) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        request.companyID = state.common.companyID;

        const getAccountRequest = {
            accountNumber: request.accountNumber,
            lastName: request.lastName,
            zipCode: request.zipCode,
            companyID: state.common.companyID
        };

        dispatch({ type: 'SET_QUICK_PAY_ACCOUNT', quickPayAccount: {}, quickPayAccountFound: false });

        var queryString = Object.keys(getAccountRequest).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(getAccountRequest[key])).join('&');

        //TODO: review webmethod
        fetch(`${state.common.serviceUrl}/AccountByZipCode?${queryString}`, { headers: headers, method: 'GET', credentials: "same-origin" })
            .then(response => CommonState.handleResponse(response, dispatch))
            .then(data => {

                if (data.account) {

                    if (!data.account.isCashOnly) {
                        dispatch({ type: 'SET_QUICK_PAY_ACCOUNT', quickPayAccount: data.account, quickPayAccountFound: true });
                    } else {
                        dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: T.translate('quickPay.accountCashOnlyMessage') });
                    }

                } else {
                    dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: T.translate('quickPay.noAccountFound') });
                }

            })
            .catch(function (error) {
                dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: error.message });
            });

        dispatch({ type: 'REQUEST_USER_START' });

    },

    postAccountQuickPay: (request) => (dispatch, getState) => {

        const state = getState();
        let headers = CommonState.headers;
        headers.Authorization = state.common.publicToken;

        request.ipAddress = state.common.ip;
        request.accountID = state.user.quickPayAccount.accountID;

        if (request.expiration && request.expiration.split('/').length === 2) {
            request.expireMonth = request.expiration.split('/')[0];
            request.expireYear = request.expiration.split('/')[1];
        }

        delete request.expiration;
        delete request.fields;
        delete request.elements;

        const TENDER_TYPE_CREDIT_CARD = 1;
        const TENDER_TYPE_ECHECK = 2;
        const tenderType = parseInt(request.tenderTypeID, 10);

        if (tenderType === TENDER_TYPE_CREDIT_CARD) {
            if (request.cardNumberValue) {
                request.cardNumber = request.cardNumberValue.replace(/-/g, '');
            }

            //remove these props that are not needed in the request
            delete request.cardNumberValue;

        } else if (tenderType === TENDER_TYPE_ECHECK) {
            if (state.common.paymentStripe) {
                request.paymentToken = `${request.public_token}|${request.account_id}`;
            }
        }

        if (request.amount) {
            request.paymentAmount = request.amount;
        } else {
            if (state.user.quickPayAccount.accountBillingTypeID === 1) {
                request.paymentAmount = state.user.quickPayAccount.suggestedPayment;
            } else {
                request.paymentAmount = state.user.quickPayAccount.totalAmountDue;
            }
        }

        // Handle iframe hosted payment page response for QuickPay
        if (request.paymentMethod === 'iFrameCreditCard' || request.paymentMethod === 'iFrameECheck') {
            request.isHostedPaymentPageResponse = true;
            request.hostedPaymentPageResponse = request.hostedPaymentPageResponse || request.transactionResponse || '';
            
            // For iFrame payments, use the token and response data
            if (request.paymentToken) {
                request.paymentToken = request.paymentToken;
            }
        } else {
            // For non-hosted payment pages, set to false
            request.isHostedPaymentPageResponse = false;
            request.hostedPaymentPageResponse = '';
        }
        
        // Set referenceNumber and notes based on payment type
        if (request.isHostedPaymentPageResponse) {
            request.referenceNumber = request.referenceNumber || `QuickPay iFrame - ${new Date().toISOString()}`;
            request.notes = request.notes || `QuickPay iFrame hosted payment page transaction`;
        } else {
            request.referenceNumber = `QuickPay - ${new Date().toISOString()}`;
            request.notes = `Payment via QuickPay portal`;
        }

        // Handle iframe payments with clean payload for QuickPay
        if (request.paymentMethod === 'iFrameCreditCard' || request.paymentMethod === 'iFrameECheck') {
            // Create clean payload for iFrame payments - only required properties per API specification
            let iFrameRequest = {
                accountID: request.accountID,
                tenderTypeID: parseInt(request.tenderTypeID),
                paymentAmount: request.paymentAmount,
                referenceNumber: request.referenceNumber || `QuickPay iFrame - ${new Date().toISOString()}`,
                notes: request.notes || `QuickPay iFrame hosted payment page transaction`,
                isHostedPaymentPageResponse: true,
                hostedPaymentPageResponse: request.hostedPaymentPageResponse || request.transactionResponse || '',
                paymentToken: request.paymentToken,
                nameOnAccount: request.nameOnAccount
            };

            // Handle card details based on payment type
            if (parseInt(request.tenderTypeID) === 1) {
                // For credit card payments, send CardNumber, ExpireYear, ExpireMonth, and CardTypeID
                iFrameRequest.cardNumber = request.cardNumber || '';
                iFrameRequest.expireYear = request.expireYear || '';
                iFrameRequest.expireMonth = request.expireMonth || '';
                
                // Add cardTypeID if it was provided
                if (request.cardTypeID) {
                    iFrameRequest.cardTypeID = request.cardTypeID;
                }
            } else if (parseInt(request.tenderTypeID) === 2) {
                // For eCheck payments, only send CardNumber with the account number from iFrame
                iFrameRequest.accountNumber = request.accountNumber || '';
            }

            fetchExternalAccountPayment(dispatch, getState, iFrameRequest);
            
        } else if (state.payment.i4GoAuthorizeClient.i4go_isEnable && state.payment.i4GoAuthorizeClient.i4go_accessblock && request.tenderTypeID === '1') {

            let cardTypeID = CommonState.getCardType(request.cardNumber);

            let requestI4Go = CommonState.getI4GoCardEntryRequest(state.payment.i4GoAuthorizeClient.i4go_accessblock, cardTypeID,
                request.cardNumber, request.expireMonth, request.expireYear, request.ccv);

            var queryString = Object.keys(requestI4Go).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(requestI4Go[key])).join('&');

            // Start loading state for i4Go API call
            dispatch({ type: 'REQUEST_USER_START' });

            fetch(`${state.payment.i4GoAuthorizeClient.i4go_server}/index.cfm?${queryString}`, { method: 'GET' })
                .then(response => CommonState.handleResponse(response, dispatch))
                .then(data => {

                    if (data.i4go_responsecode === '1' && data.i4go_uniqueid) {

                        let req = {};
                        req.paymentAmount = request.paymentAmount;
                        req.paymentToken = data.i4go_uniqueid;
                        req.ipAddress = request.ipAddress;
                        req.accountID = request.accountID;
                        req.cardZipCode = request.cardZipCode;
                        req.nameOnAccount = request.nameOnAccount;
                        req.tenderTypeID = request.tenderTypeID;
                        req.i4GoCardType = CommonState.getI4GoCardType(cardTypeID);

                        fetchExternalAccountPayment(dispatch, getState, req);

                    } else {
                        dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: data.i4go_responsetext });
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: error.message });
                });

        } else {
            fetchExternalAccountPayment(dispatch, getState, request);
        }

    },

    quickPay: (request) => (dispatch, getState) => {
        return actionCreators.postAccountQuickPay(request)(dispatch, getState);
    },

    setQuickPayModalVisible: (quickPayModalVisible) => (dispatch) => {
        dispatch({ type: 'SET_QUICK_PAY_MODAL_VISIBLE', quickPayModalVisible });
    },

    clearUserState: () => (dispatch) => {
        dispatch({ type: 'CLEAR_USER_STATE' });
    },

    setError: (errorMessage) => (dispatch) => {
        dispatch({ type: 'SET_USER_ERROR', userErrorMessage: errorMessage });
    },

    setQuickPayError: (errorMessage) => (dispatch) => {
        dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: errorMessage });
    }

};

var fetchExternalAccountPayment = async function (dispatch, getState, req) {

    const state = getState();
    let headers = { ...CommonState.headers }; 
    //CV ZD14560 2020/03/26 adding this to exclude the stripe objects from the request body, and prevent the circular reference problem
    var requestBody = JSON.stringify(req, (key, value) => {
        if (key === "stripe" || key === "elements" || key === "cardNumberElement" || key === "cardExpiryElement" || key === "cardCvcElement") return null;
        else return value;
    });

    // force CSRF token in the header
    const csrfToken = await CommonState.fetchCSRFToken();
    if (!csrfToken) {
      console.error("Failed to get CSRF token");
      return;
    }
    headers['X-MyAccount-CSRF-TOKEN'] = csrfToken;

    // Start loading state
    dispatch({ type: 'REQUEST_USER_START' });

    let apiUrl = `${state.common.serviceUrl}/${req.isHostedPaymentPageResponse ? 'ExternalApprovedAccountPayment' : 'ExternalAccountPayment'}`;

    fetch(apiUrl, { headers: headers, method: 'POST', body: requestBody, credentials: "same-origin" })
        .then(response => CommonState.handleResponse(response, dispatch))
        .then(data => {

            if (data.isApproved) {
                dispatch({ type: 'SET_QUICK_PAY_SUCCESS', quickPaymentSuccess: true, quickPayConfirmationNumber: data.paymentConfirmationNumber });
            } else {
                dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: data.errorMessage });
            }
        })
        .catch(function (error) {
            dispatch({ type: 'SET_QUICK_PAY_ERROR', quickPayErrorMessage: error.message });
        });

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case 'REQUEST_USER_START':
            return { ...state, userLoading: true, userErrorMessage: '', quickPayErrorMessage: '' };
        case 'REQUEST_USER_END':
            return { ...state, userLoading: false };
        case 'REQUEST_AUTOLOGIN_END':
            return { ...state, userLoading: false, resetPwdInfo: action.resetPwdInfo };
        case 'SET_USER_ERROR':
            return { ...state, userErrorMessage: action.userErrorMessage, userLoading: false, userSourceError: action.userSourceError };
        case 'SET_USER_ERROR_FOR_MODAL':
            return { ...state, userLoading: false, userErrorMessageModal: action.userErrorMessageModal };
        case 'SET_QUICK_PAY_ERROR':
            return { ...state, quickPayErrorMessage: action.quickPayErrorMessage, userLoading: false };
        case 'SET_QUICK_PAY_ACCOUNT':
            return { ...state, quickPayAccount: action.quickPayAccount, userLoading: false, quickPayAccountFound: action.quickPayAccountFound };
        case 'SET_QUICK_PAY_SUCCESS':
            return { ...state, userLoading: false, quickPaymentSuccess: action.quickPaymentSuccess, quickPayConfirmationNumber: action.quickPayConfirmationNumber };
        case 'SET_FORGOT_PASSWORD_CONFIRMATION':
            return { ...state, userLoading: false, forgotPasswordConfirmation: action.forgotPasswordConfirmation };
        case 'SET_FORGOT_USERNAME_CONFIRMATION':
            return { ...state, userLoading: false, forgotUsernameConfirmation: action.forgotUsernameConfirmation };
        case 'SET_REGISTER_CONFIRMATION':
            return { ...state, userLoading: false, registerConfirmation: action.registerConfirmation };
        case 'SET_USERNAME_UPDATE_CONFIRMATION':
            return { ...state, userLoading: false, usernameUpdateConfirmation: action.usernameUpdateConfirmation, confirmRememberMe: action.confirmRememberMe };
        case 'SET_REGISTER_USER_FOUND':
            return { ...state, userLoading: false, registerUserFound: action.registerUserFound, registerPerson: action.registerPerson };
        case 'SET_ACCOUNT_REGISTERED':
            return { ...state, userLoading: false, accountRegistered: action.accountRegistered };
        case 'SET_VERIFICATION_CODE_CONFIRMATION':
            return { ...state, userLoading: false, verificationCodeConfirmation: action.verificationCodeConfirmation };
        case 'SET_ACCOUNT_VERIFICATION_CONFIRMATION':
            return { ...state, userLoading: false, accountVerificationConfirmation: action.accountVerificationConfirmation };
        case 'SET_ENROLLMENT_VERIFICATION':
            return { ...state, userLoading: false, verifiedEnrollment: action.verifiedEnrollment };
        case 'SET_VALID_PASSWORD_RESET_TOKEN':
            return { ...state, userLoading: false, resetPwdInfo: action.resetPwdInfo };
        case 'SET_AUTOLOGIN_TOKEN':
            return { ...state, userLoading: false, resetPwdInfo: action.resetPwdInfo };
        case 'SET_QUICK_PAY_MODAL_VISIBLE':
            if (!action.quickPayModalVisible) {
                return {
                    ...state,
                    quickPayModalVisible: false,
                    quickPayAccountFound: false,
                    quickPaymentSuccess: false,
                    quickPayErrorMessage: '',
                    quickPayConfirmationNumber: ''
                };
            }

            return { ...state, quickPayModalVisible: true };
        case 'CLEAR_USER_STATE':
            return initialState;
        case 'SET_ACCOUNT_VERIFIED':
            return { ...state, userLoading: false, accountVerified: action.accountVerified };
        default:
            return state;
    }

};
